<template>
  <section id="launch" class="p5">
    <div class="container">
      <div class="support">
        <h1>Full support for your launch</h1>
      </div>

      <div
        id="accordionFlushExample"
        class="accordion accordion-flush m-auto py-5"
      >
        <!-- Item 1 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
            >
              Storefront and email setup
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              We have amazing in-house graphic designers and copywriters who can
              help you set up a website that fits your style and vibe in a short
              amount of time.
            </div>
          </div>
        </div>
        <!-- Item 2 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
            >
              Console training
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              Although we make sure all the tools we provide are easy to use, we
              still conduct console trainings where we walk you through our
              system’s capabilities to help you maximize the use of our
              technology.
            </div>
          </div>
        </div>
        <!-- Item 3 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseThree"
            >
              Marketing consultations
            </button>
          </h2>
          <div
            id="flush-collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              As experts in e-commerce, we guide creators and communities in
              formulating marketing strategies that are proven effective in the
              industry.
            </div>
          </div>
        </div>
        <!-- Item 4 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFour"
            >
              Operations assistance
            </button>
          </h2>
          <div
            id="flush-collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              One-man creator teams won’t have to worry about handling their
              storefront and community operations alone, since we are always
              there to help, whether it be daily shipments or monthly events.
            </div>
          </div>
        </div>
        <!-- Item 5 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFive"
            >
              Timely updates
            </button>
          </h2>
          <div
            id="flush-collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              We make sure that you are updated with all our new features and
              campaigns! We have an announcement section on our console, and a
              groupchat on Telegram to make information dissemination easier!
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.accordion-header:focus,
.accordion-header button:focus {
  box-shadow: none;
}

.accordion-body {
  line-height: 1.5;
}

.container,
section {
  width: 100%;
  padding: 3rem 0;
}

.support {
  max-width: 60rem;
  margin: auto;
  text-align: center;
}

.support h1 {
  font-size: 3.5rem;
  font-weight: 700;
  color: #ff5f8f;
}

.accordion {
  max-width: 50rem;
}

.accordion-item button {
  font-size: 1.5rem;
  color: black;
}

.accordion-item button:focus {
  color: #25a4e1;
}

@media screen and (max-width: 800px) {
  .support h1 {
    font-size: 2.5rem;
  }

  .container {
    width: 90%;
  }

  .accordion-item button {
    font-size: 1rem;
  }

  section {
    padding: 2rem 0;
  }
}
</style>
